

import { Injectable, Inject } from '@angular/core';
import { Observable, of, combineLatest, onErrorResumeNext, Subject } from 'rxjs';
// tslint:disable-next-line: max-line-length
import { DwMdFormActionHandler, DwMdFormActionState, DwMdFormActionResult, DwFormAction, DwSecuritySSOService, DwSecurityRepositoryServiceToken, 
         DwSecurityRepositoryService, DwSecurityUserService, DwMdFormContextInfo, DwOrmDataService, DwOrmDataServiceToken, DwMdFormInitActionHandler, 
         DwMdFormInitActionState, DwAction, DwActionType, DwMessagingService, DwMessageSeverity } from '@devwareapps/devware-cap';
import { map, catchError, flatMap, tap } from 'rxjs/operators';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { TermResignEntity } from 'src/app/meta-data/app-meta-data.service';
import { ConfigService } from 'src/environments/environment';
import { FormGroup } from '@angular/forms';
import { WachterUserExt } from 'src/app/shared/models/wachter-user.model';
import { AppPermissions } from 'src/app/meta-data/app-permissions.enum';
import { AppMetaDataItemNames } from 'src/app/meta-data/app-meta-data.service';



@DwAction ({
  isGlobal: false,
  actionType: DwActionType.formAction,
  display: 'PAF Term Resign Resend Email',
  keyName : 'pafTermResignResendEmail',
  actionMessage: '',
  parentItemName : AppMetaDataItemNames.TermResign,
  defaultButtonConfig : {
    buttonText : 'Resend Email',
    buttonTitle : 'Resend Email',
    command : 'resendTermResignEmail',
    iconClass : 'fas fa-envelope',
    buttonClass : 'btn btn-success'
  }
})
@Injectable({
  providedIn: 'root'
})
export class TermResignResendEmailActionService implements DwMdFormActionHandler, DwMdFormInitActionHandler  {

   constructor(
     protected msalHandler: DwSecuritySSOService,
     protected securityService: DwSecurityUserService,
     @Inject(DwSecurityRepositoryServiceToken) protected securityRepository: DwSecurityRepositoryService,
     @Inject(DwOrmDataServiceToken) protected ormDataService: DwOrmDataService,
     protected http: HttpClient,
     protected messageService: DwMessagingService) {
  }

  /**
   * Initialize the action to customize any config items
   * @param formInitActionState form state
   */
  initAction(formInitActionState: DwMdFormInitActionState) {
    // Wait for value changes
     formInitActionState.formApi.formGroup.valueChanges.subscribe(value => {
       this.updateButton(formInitActionState);
    });

    return;
  }

  /**
   * Updates the button config based on if they can approve or not
   * @param formInitActionState form state
   */
  protected updateButton(formInitActionState: DwMdFormInitActionState) {
    const buttonConfig = formInitActionState.actionPreference.buttonConfig;
    // Set button disabled based on can Approve result
    if (buttonConfig) {
      buttonConfig.hidden = !this.canPress(formInitActionState);
    }
  }

  handleAction(formActionState: DwMdFormActionState): Observable<DwMdFormActionResult> {
    const result: DwMdFormActionResult = { success : true, message : 'Sent Email!' };
    const cannotApproveResult: DwMdFormActionResult = { success : false, message : 'You cannot use this button.' };

    if (!this.canPress(formActionState)) {
      return of (cannotApproveResult);
    }

    const termResign: TermResignEntity = formActionState.formApi.getFormData();
    if (ConfigService.config.features.paf.workflowPort === true){
      const url = ConfigService.config.apiRoot + '/termResign/resend';

      var headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');
      const resultObs = this.http.get(url + '?id=' + termResign.TermResignId, { headers, responseType: 'text' as 'json' })
                                 .pipe(map((res: any) => { 
                                          if (res) { 
                                            cannotApproveResult.message = res; 
                                            return cannotApproveResult; 
                                          }
                                          else
                                            this.sendInfoMsg('Email scheduled successfully for resend!');
                                          return result; 
                                        }),
                                        catchError(err => { 
                                          cannotApproveResult.message = err.message; 
                                          return of(cannotApproveResult);
                                        }));
      this.sendInfoMsg('Attempting to resend...');
      return resultObs;
    }

    // const result: DwMdFormActionResult = {
    //   success : true,
    //   message : 'Sent Email!',
    // };
    // const cannotApproveResult: DwMdFormActionResult = {
    //   success : false,
    //   message : 'You cannot use this button.',
    // };

    // if (!this.canPress(formActionState)) {
    //   return of (cannotApproveResult);
    // }
    // const termResign: TermResignEntity = formActionState.formApi.getFormData();

    // this.http.post(ConfigService.config. wAppsApi + 'api/TermResign',termResign).subscribe(x => console.log('Email sent!'));
  }
  private sendInfoMsg(msg : string){
    this.messageService.showMessage({messageHeading: '', messageBody: msg, severity: DwMessageSeverity.info });
  }

   /**
   * Determines if the user can approve/reject the request
   * @param formActionState form state
   */
  protected canPress(formActionState: DwMdFormActionState): boolean {
    const wachterUser = new WachterUserExt(this.securityService.securityContext.ApplicationUser);

    if (wachterUser.hasPermission(AppPermissions.canResendPAFChangeEmails)) {
      return true;
    }

    return false;
  }

}
